<template>
  <div>
    <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :search="filters.search"
        :custom-filter="customFilter"
        fixed-header
        class="neris-stations-table header-nowrap"
        no-data-text="No data available"
        no-results-text="No data available"
    >
      <template v-slot:item.units="{ item }">
        <v-chip
          small
          @click="$emit('clickItems', item)"
        >{{ item.units }}</v-chip>
      </template>
      <template v-slot:item.actions="{ item }">
        <div class="actions no-wrap text-right align-right">
          <v-icon
              color="grey darken-2 "
              class="mr-3"
              @click="$emit('edit', item)"
          >
            edit
          </v-icon>
          <v-icon
              class="mr-3"
              color="grey darken-2"
              @click="$emit('delete', item)"
          >
            delete
          </v-icon>
        </div>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import neris from '@/api/neris';

export default {
  name: 'StationsTable',

  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
      headers: [
        {
          text: 'Station ID',
          value: 'stationId',
        },
        {
          text: 'Internal ID',
          value: 'internalId',
        },
        {
          text: 'Address Line 1',
          value: 'addressLine1',
        },
        {
          text: 'City',
          value: 'city',
        },
        {
          text: 'State',
          value: 'state',
        },
        {
          text: 'Zip Code',
          value: 'zipCode',
        },
        {
          text: 'Units',
          value: 'units',
        },
        {
          text: '',
          value: 'actions',
          sortable: false,
          width: '100px',
        },
      ],
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    customFilter(value, search, item) {
      return (
        item.stationId.toLowerCase().includes(search.toLowerCase())
          || item.internalId.toLowerCase().includes(search.toLowerCase())
          || item.addressLine1.toLowerCase().includes(search.toLowerCase())
      );
    },
    async fetchData() {
      try {
        this.loading = true;
        const response = await neris.getStations({});
        this.items = response.data;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" module>
.actions {
  width: 20%;
}
</style>
<style lang="scss">
.neris-stations-table {
  .v-data-table__wrapper {
    height: calc(100vh - 310px);
  }
  thead {
    th {
      z-index: 1 !important;
    }
  }
}
</style>
